<template>
  <div v-if="info" class="survey-question-main">
    <div class="headerBox" :class="info.campaignSurveyDescription===null|| info.campaignSurveyDescription==='' ? 'headerTitle' :'' ">
      <div style="height: 2px;color: rgba(0,0,0,0)">`</div>
      <div class="headerBox-title" >{{ info.campaignSurveyName }}</div>
      <div class="headerBox-main" v-html="info.campaignSurveyDescription" style="color: #ffffff"></div>
    </div>
    <div class="main">
      <questionnaire :infoList="info" :isShowTitleNumber="true" :submitStyle="false" :isPaySuccess="false"
        :orderId="orderId" :bookingRdId="bookingRdId"></questionnaire>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import Questionnaire from "@/components/Questionnaire/Questionnaire.vue";
export default {
  name: "SurveyQuestion",
  components: { Questionnaire },
  data() {
    return {
      type: '',
      info: null,
      titleCenter: false,
      bookingRdId: null,
      orderId: null,
    }
  },
  beforeMount() {
    this.$store.commit('SET_PAGE_TITLE', '调查问卷')
    this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: true })
  },
  created() {
    let query = this.$route.query;
    this.type = query.type || 'HOME';
    this.getQuestions();
    this.bookingRdId = query.bookingRdId || '';
    this.orderId = query.orderId || '';
  },
  methods: {
    async getQuestions() {
      this.$loading.show()
      const { success, data } = await api.questionnaire.getCampaignQuestions({
        type: this.type
      })
      this.$loading.hide()
      if (success) {
        console.log(data);
        let { campaignSurveyPageTitle } = data;
        this.info = this.surveyFormat(data, null);
        this.$store.commit('SET_PAGE_TITLE', campaignSurveyPageTitle)
      }
    },
    // 数据处理
    surveyFormat(rows, type, defaultVal) {
      let customTypeIcon = {
        "Booking": "liucheng.png",
        "ImportantInfo": "info-1.png",
        "CustomerService": "custom-service.png"
      }
      rows.categoryQuestionItems && rows.categoryQuestionItems.forEach((row, idx) => {
        if (rows.categoryQuestionItems[0].questionItems[0].customType === "Point") {
          row.show = idx === 0;
        } else {
          row.show = true;
        }
        row.questionItems && row.questionItems.forEach((qtItem) => {
          qtItem.value = qtItem.type === 4 ? defaultVal : null;
          qtItem.isFocus = false;
          qtItem.icon = customTypeIcon[qtItem.customType]
          if (qtItem.type === 4) {
            let indexList = [];
            for (let i = 1; i <= 10; i++) {
              indexList.push({
                text: i,
                selectClass: ""
              })
            }
            qtItem.indexList = indexList;
          }
          qtItem.optionItems && qtItem.optionItems.forEach((option) => {
            option.checked = false;
            option.otherVal = "";
            option.isOther = option.optionName === "其他" || option.optionName === "其它";
            qtItem.isOther = option.isOther;
          })
        })
        row.NO = (idx + 1) > 9 ? (idx + 1) : `0${idx + 1}`
      });
      console.log(rows)
      return rows;
    }
  }
}
</script>
<style scoped lang="less">
.survey-question-main {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  padding-bottom: 100px;
}

.headerBox {
  width: 1200px;
  padding: 5px 10px 10px 10px;
  color: #ffffff;
  margin: 0 auto;
  background: linear-gradient(326deg, #FFFFFF 0%, #2493F4 99%);
}

.headerBox .headerBox-title {
  width: 100%;
  font-size: 20px;
}

.headerBox .headerBox-main ::v-deep p {
  margin: 0;
}
.headerTitle{
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
  font-weight: 600;
  line-height: 50px;
  background: url("https://resource.rcclchina.com.cn/questionnaire/headerBg.jpg") no-repeat 100% 100% !important;
}
</style>
